module.exports = __webpack_public_path__ + "static/media/CANIMOLT_PortadaCompendio_cap2.7116c1d2.jpg";